<template>
  <div class="group-manage-detail conmon-top">
    <el-container v-loading="loadingAll">
      <!--左侧分组-->
      <el-aside class="left-menu-item">
        <div
          class="group-detail"
          style="box-sizing: border-box"
        >
          <div
            class="title"
            style="font-size:14px"
          >
            <i
              class="iconfont icon-icon-liebiao"
              style="color:#333;font-size:12px;margin-right:8px"
            ></i>
            群组详情
            <i
              @click="editGroup"
              class="iconfont icon-icon-bianji"
              style="float: right;cursor: pointer;margin-right: 10px;color: #1890FF;"
            ></i>
          </div>
          <div class="detail-item">
            <div class="label">群组名称:</div>
            <div class="value">{{ groupName }}</div>
          </div>
          <div class="detail-item">
            <div class="label">类型:</div>
            <div class="value">
              {{ groupsTypeObj[query.type] }}
            </div>
          </div>
          <div class="detail-item">
            <div class="label">客户人数:</div>
            <div
              class="value"
              v-if="customerCount > -1 && showNum === 0"
            >
              {{ customerCount }}
              <i
                v-if="type === 1"
                class="el-icon-refresh refresh"
                title="刷新客户"
                @click="refreshCustomer"
              ></i>
            </div>
            <div
              class="value"
              v-if="showNum === 1"
            >
              <span style="color: #FFA873">
                <i class="el-icon-time"></i>
                正在统计中
              </span>
            </div>
          </div>
          <div class="detail-item">
            <div class="label">最后更新时间:</div>
            <div class="value">{{ query.update_time | formatDate }}</div>
          </div>
          <div
            class="detail-item"
            style="border-bottom: none"
          >
            <div class="label">创建日期:</div>
            <div class="value">{{ query.create_time | formatDate }}</div>
          </div>
        </div>
        <!--群组条件（动态群组有）-->
        <!--<div v-if="type === 1" class="group-detail" style="padding-bottom: 10px;margin-top: 10px">-->
        <!--<div class="title">-->
        <!--<i class="iconfont icon-icon-dingdanjilu" style="color: #4882ff"></i>-->
        <!--群组条件-->
        <!--</div>-->
        <!--<div class="terms">{{ queryTerms }}</div>-->
        <!--</div>-->
      </el-aside>
      <!--右侧列表-->
      <div style="padding: 0;width: calc(100% - 300px)">
        <div
          class="base-input ovf-hd"
          style="margin-bottom: 10px"
        >
          <el-row class="search-title">
            <el-col
              :span="5"
              class="table-title"
            >
              <i
                class="el-icon-search"
                style="font-weight: bold;"
              ></i>
              <span class="order-list-search-span">筛选查询</span>
            </el-col>
            <el-col
              :span="19"
              class="text-align-right"
            >
              <el-button
                class="search-open-close"
                type="text"
                @click="hide=!hide"
              >{{ hide? '收起查询':'展开查询' }}</el-button>
              <i
                v-if="hide === true"
                class="el-icon-arrow-up search-open-close-i"
                @click="hide=!hide"></i>
              <i
                v-if="hide === false"
                class="el-icon-arrow-down search-open-close-i"
                @click="hide=!hide"></i>
              <el-button
                class="search-btn-new"
                type="primary"
                size="small"
                v-if="!isShowHigherSearch"
                @click="startLoad"
              >查询</el-button>
            </el-col>
          </el-row>
          <el-row
            class="search-content"
            v-show="hide"
            v-if="!isShowHigherSearch"
            style="line-height: 50px"
          >
            <el-col
              :span="24"
              class="text-align-left common-search-formtype"
              style="margin-left: 22px;"
            >
              <span style="margin-left: 26px;">创建时间：</span>
              <el-date-picker
                style="width: 370px!important;"
                class="operationTime operationTimePicker"
                v-model="timeaa"
                type="datetimerange"
                @change="consoles"
                range-separator="至"
                :default-time="['00:00:00', '23:59:59']"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-col>
          </el-row>
          <!--高级查询-->
          <el-row
            class="search-content"
            v-show="hide"
            v-if="isShowHigherSearch"
          >
            <div class="hei-ser">
              <el-button
                type="primary"
                :disabled="isDisabled"
                class="add-btn"
                style="border: none;margin-left: 0;margin-right: 10px;margin-top:18px"
                @click="handleReset"
              >重置</el-button>
              <el-button
                type="primary"
                style="margin-right: 16px;margin-top:18px"
                class="add-btn"
                @click="handleRemoveFromGroup"
              >移出群组</el-button>
              <el-button
                type="primary"
                style="margin-right: 16px;margin-top:18px"
                class="add-btn"
                @click="startPreView"
              >开始查询</el-button>
            </div>
            <div style="text-align: left;padding-bottom: 10px">
              <span style="margin-left: 20px">查询条件：</span>
            </div>
            <!-- <higher-search-audiences
              class="common-search-formtype customer-manage-higher-search"
              :forSonTerms="forSonTerms"
              :allRelationship="allRelationship"
              @change="getAllTerms"
              style="margin-top: 10px"
            ></higher-search-audiences> -->
            <higher-search-audiences
              :modelId="$route.params.id"
              class="common-search-formtype customer-manage-higher-search group-item-style high-search-cascader aud-manage"
              :forSonTerms="forSonTerms"
              :isAnalyse="isAnalyse"
              :allRelationship="allRelationship"
              @change="getAllTerms"
              style="margin-top: 10px"
            ></higher-search-audiences>
          </el-row>
        </div>
        <el-row
          class="search-title common-table-top"
          style="padding-right: 0"
        >
          <el-col
            :span="5"
            class="table-title"
          >
            <i
              class="el-icon-document"
              style="font-weight: bold;"
            ></i>
            <span>客户列表</span>
          </el-col>
          <el-col
            :span="19"
            class="text-align-right"
          >
            <!--<div class="add-btn">导出客户</div>-->
            <el-button
              type="primary"
              v-if="type === 2"
              style="margin-right: 32px"
              class="add-btn"
              @click="addNewCustomer"
            >添加客户</el-button>
            <el-button
              type="primary"
              class="add-btn"
              :class="type === 1 ? 'mr32' : 'mr16'"
              @click="downloadFiles"
            >导出</el-button>
          </el-col>
        </el-row>
        <!--客户列表-->
        <el-table
          class="audiences-table-content audiences-table-contents"
          v-loading="loading"
          :data="tableData"
          border
        >
          <template slot="empty">
            <div class="newTableEmpty">没有更多数据了</div>
          </template>
          <el-table-column
            :sortable="data.isSort"
            min-width="160"
            :label="data.label"
            v-for="data in headerList"
            :key="data.identity"
            :prop="data.identity"
          >
            <template slot-scope="scope">
              <img
                v-if="data.identity == 'avatar'"
                style="width: 32px; height: 32px; display: block; border-radius: 50%; text-align: left; float: left; margin-right: 10px;"
                :src="scope.row[data.identity] | showImgUrl"
              />
              <div
                v-else
                :class="isSafari ? 'aud-show-divs' : 'aud-show-div'"
              >
                <span :title="scope.row[data.identity]">{{ scope.row[data.identity] }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-show="loading === false"
            class="aud-operatopn-div"
            fixed="right"
            label="操作"
            width="160"
          >
            <template slot-scope="scope">
              <div class="op-link">
                <span
                  class="op-link"
                  @click="toAudDetail(scope.row)"
                  size="small"
                >查看</span>
              </div>
              <div
                class="op-link"
                v-if="isShowHigherSearch"
              >
                <span
                  class="op-link"
                  @click="deleteItem(scope.row)"
                  size="small"
                >删除</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="table-foot"
          style="text-align: right"
        >
          <el-pagination
            class="table-foot-pagination"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="limit"
            :current-page="page"
            layout="total, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </el-container>

    <!--编辑群组弹窗-->
    <el-dialog
      class="cellDialog base-dialog"
      title="编辑静态群组"
      :visible.sync="editDialog"
      width="520px"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="rules"
      >
        <el-form-item
          label="所属分组:"
          :label-width="addLabelWidth"
          >
          <el-select
            class="common-search-formtype"
            style="margin-right: 13px;"
            v-model="editForm.group_id"
            placeholder="请选择所属分组"
            clearable>
            <el-option
              v-for="item in queryGroups"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="群组名称:"
          :label-width="addLabelWidth"
          prop="name"
        >
          <el-input
            class="stockInput"
            type="text"
            v-model="editForm.name"
            auto-complete="off"
            placeholder="输入群组名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
        style="margin-top: 10px"
      >
        <el-button
          class="dialog-cancel-btn"
          @click="editDialog = false"
          style="margin-left: 20px;"
        >取 消</el-button>
        <el-button
          class="dialog-confirm-btn"
          @click="confirmEditGroup"
          type="primary"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { exportCustomer, getGroupList, getWechatPublicListForNode, getQrCodeList, WePagesList, getBigWheelList, getMessageListForNode, getCustomerAttributeList, getCustomerStage, getSourceData, refreshCustomer, editGroupManageDetail, addGroupManageDetail } from '@/api/customer.js'
import { getAudiencesList, getAudGroupDetail, getAudExportList, getAudGroupGroupList, audEditGroup, getCusTypes, getAudListShowSix, getCusAttrList, deleteStaticGroup, batchDeleteStaticGroup } from '@/api/set.js'
import HigherSearchAudiences from './../common/higher-search-audiences.vue'
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
import { deleteTermsSendKey } from '../../api/publicMethods'
import { FIRST_PAGE, GROUP_TYPE_OBJ, GROUP_TYPE, initAuDetailSonTermsList, resetForSonTerms, IS_CHECKED, INIT_SEARCH } from './constant'
import { judgeIsEmpty } from '../../api/publicMethods'
export default {
  name: 'groupManageDetil',
  data () {
    return {
      isAnalyse: false,
      showNum: 0,
      loadingAll: true,
      modelData: [],
      isSafari: false,
      rules: {
        name: [
          { required: true, message: '群组名字不能为空', trigger: 'change' }
        ]
      },
      queryGroups: [],
      group_id: '',
      groupName: '',
      loading: false,
      headerList: [],
      downloadUse: 0,
      isHigher: false,
      isShow: true,
      tableData: [],
      searchData: [],
      limit: 10,
      totalCount: 0,
      customerCount: 0,
      adddialog: false,
      editDialog: false,
      addForm: {
        name: ''
      },
      editForm: {
        name: '',
        group_id: ''
      },
      addLabelWidth: '90px',
      dialogType: 0,
      editId: '',
      page: 1,
      hide: true,
      isDisabled: false,
      closeChoose: '收起筛选',
      search: {
        start_time: '',
        end_time: ''
      },
      groupsTypeObj: GROUP_TYPE_OBJ,
      allTerms: {},
      downloadSearch: {},
      allTermsCopy: {},
      queryTerms: '',
      type: 0,
      query: {},
      timeaa: null,
      lastId: 0,
      saveType: 0,
      allRelationship: '',
      forSonTerms: initAuDetailSonTermsList,
      result: [],
      identities: [],
      len: 0,
      isShowSearchRes: false,
      downloadQuery: {},
      rowLists: [],
      isShowHigherSearch: false,
      checkedRowList: []
    }
  },
  components: {
    'higher-search-audiences': HigherSearchAudiences,
  },
  methods: {
    //重置 恢复初始值
    handleReset () {
      this.forSonTerms = [{
        inOperator: 'and',
        terms: [{
          attr: 'attr',
          attr_label: '',
          relationship: '',
          relationOptions: [{
            value: 'equal',
            label: '等于'
          }, {
            value: 'not_equal',
            label: '不等于'
          }, {
            value: 'contain',
            label: '包含'
          }, {
            value: 'empty',
            label: '为空'
          },
          {
            value: 'not_empty',
            label: '不为空'
          }
          ],
          value: null,
          option: [],
          //              original_id: null,
          //              eventAttributeList: [],
          //              activitiesTwo: [],
          //              templatesTwo: [],
          //              wepageTwo: [],
          eventAttrOptions: [{
            attributeContent: '',
            relationOptions: [],
            sources: [],
            eventAttrValueOptions: [],
            attributeRelation: '',
            attr_type: '',
            attrValTimeStart: '',
            attrValTimeEnd: '',
            attributeValueStart: '',
            attributeValueEnd: '',
            attributeValue: ''
          }],
          //              optionOther: null,
          //              qrcodeOptions: null,
          //              templateOption: null,
          //              qrcode: null,
          //              offline_qrcode: null,
          //              template_id: null,
          //              leave_word: null,
          //              public_reply_type_all: {
          //                reply_type: '不限',
          //                reply_content: ''
          //              },
          //              eventLimitTime: false,
          //              eventLimitTimes: false,
          //              eventLimitAttr: false,
          //              eventTimeRelation: '',
          //              eventDateStart: '',
          //              eventDateEnd: '',
          //              happenedTimes: '',
          //              start_time: '',
          //              end_time: '',
          selectedOptions: ['attr', '']
        }]
      }]
      this.allRelationship = ''
      this.allTerms = INIT_SEARCH
      this.page = FIRST_PAGE
      this.load()
    },

    //移除群组 批量删除
    handleRemoveFromGroup () {
      const idList = this.tableData.map(ele => ele.id)
      if (!judgeIsEmpty(this.allTerms.termsGroup)) {
        return
      }
      if (idList.length === 0) {
        _g.toastMsg('warning', '数据为空,请选择数据')
        return
      }
      this.handleBatchDelete()
    },

    //   批量删除静态 群组
    handleBatchDelete () {
      let termsSend = JSON.parse(JSON.stringify(this.allTerms))
      deleteTermsSendKey(termsSend)
      const { id: userGroupId } = this.$route.query
      const { id: modelId } = this.$route.params
      this.$confirm('确认删除这些受众?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const result = await batchDeleteStaticGroup(modelId, this.checkedRowList, termsSend, userGroupId)
        if (result.data.code == 200) {
          this.handleReset()
          _g.toastMsg('success', '删除受众成功')
        } else {
          _g.toastMsg('error', res.data.message)
        }
      }).catch((error) => {
        _g.toastMsg(error.message)
      })
    },

    // 列表单条删除
    deleteItem (item) {
      const idList = item.id.split()
      this.handleSingleDelete(idList)

    },

    //删除弹窗
    handleSingleDelete (idList) {
      const modelId = this.$route.params.id.split()
      const { id: groupId } = this.$route.query

      this.$confirm('确认删除该受众?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const result = await deleteStaticGroup(modelId, idList, groupId)
        if (result.data.code == 200) {
          this.load()
          this.handleReset()
          _g.toastMsg('success', '删除受众成功')
        } else {
          _g.toastMsg('error', res.data.message)
        }
      }).catch((error) => {
        _g.toastMsg(error.message)
      })
    },

    // 获取列表名字
    getAudiencesName (modelId, to) {
      getCusTypes().then((res) => {
        if (res.data.code == 200) {
          this.modelData = res.data.result
          let id = this.$route.params.id
          for (let item of this.modelData) {
            if (item.id == id) {
              let arr = to.meta.routeArr
              arr[0].name = item.name + '群组管理'
              arr[0].Rpath = '/home/audiences-group-manage/' + modelId
              arr[1].name = item.name + '群组详情'
              arr[1].Rpath = '/home/aud-group-manage-detail/' + modelId + '?id=' + this.$route.query.id + '&type=' + this.$route.query.type
              this.$store.state.breadcrumb = to.meta.routeArr
            }
          }
        }
      })
    },
    consoles (value) {
      console.log(this.timeaa)
    },
    // 跳转受众详情
    toAudDetail (item) {
      let modelId = this.$route.params.id
      let temp = ''
      getCusTypes().then((res) => {
        if (res.data.code == 200) {
          for (let item of res.data.result) {
            if (modelId == item.id) {
              temp = item.template
            }
          }
          if (temp === 'B端模板') {
            router.push({ path: '/home/model-business', query: { id: item.id, modelId: modelId, useName: this.useName } })
          } else {
            router.push({ path: '/home/model-consumer', query: { id: item.id, modelId: modelId, useName: this.useName } })
          }
        }
      })
    },
    // 确认编辑静态群组
    confirmEditGroup () {
      const { id: modelId, } = this.$route.params
      const { type, id } = this.$route.query
      let data = {
        id,
        modelId,
        type,
        name: this.editForm.name,
        groupId: this.editForm.group_id || 0,
        search: {}
      }
      audEditGroup(data).then((res) => {
        if (res.data.code == 200) {
          _g.toastMsg('success', res.data.message)
          this.load()
          this.editDialog = false
        } else {
          _g.toastMsg('error', res.data.message)
          this.editDialog = false
        }
      })
    },
    // 获取所属分组名字
    getAudGroupGroupLists (modelId) {
      if (!modelId) {
        modelId = this.$route.params.id
      }
      getAudGroupGroupList(modelId, '').then((res) => {
        if (res.data.code == 200) {
          // res.data.result.unshift({
          //   id: 0,
          //   name: '全部'
          // })
          this.queryGroups = res.data.result
        }
      })
    },
    // 群组编辑
    editGroup () {
      const { id: modelId, } = this.$route.params
      const { type, id } = this.$route.query
      if (+type === 1) {
        router.push({ path: '/home/audiences-group-manage-add/' + modelId + '?type=' + type + '&id=' + id })
      } else {
        this.editDialog = true
        this.editForm.name = this.groupName
      }
    },
    // 解析时间
    evalTime (time) {
      let date = new Date(time)
      let year = date.getFullYear()
      let mon = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return year + '-' + mon + '-' + day + ' ' + h + ':' + m + ':' + s
    },
    // 开始初级查询
    startLoad () {
      this.load()
    },
    // 开始预览
    startPreView () {
      this.downloadUse = 2
      this.preView()
    },
    // 预览
    async  preView () {
      // 判断是否为空
      if (!judgeIsEmpty(this.allTerms.termsGroup)) {
        return
      }
      this.isShow = false
      let termsSend = JSON.parse(JSON.stringify(this.allTerms))
      deleteTermsSendKey(termsSend)
      const { id: userGroupId, type: groupType } = this.$route.query
      const { id: modelId } = this.$route.params
      const res = await getAudGroupDetail(userGroupId, this.search.start_time,
        this.search.end_time, this.page, this.limit, 1, this.checkedRowList, modelId, termsSend, +groupType)

      if (res.data.code == 200) {
        this.isHight = true
        for (let one of res.data.result.header) {
          if (one.type === 'number' || one.type === 'datePicker' || one.type === 'dateTimePicker') {
            one.isSort = 'custom'
          }
        }
        for (let child of res.data.result.list) {
          if (child.sys_create_time === '1970-01-01 08:00:00') {
            child.sys_create_time = ''
          }
          if (child.birthday === '1900-01-01') {
            child.birthday = ''
          }
        }
        const { list, header, total } = res.data.result
        this.tableData = list
        this.headerList = header
        this.totalCount = total
      }
    },

    // 保存查询条件
    saveThis () {
      // 判断是否为空
      if (!judgeIsEmpty(this.allTerms.termsGroup)) {
        return
      }
      if (this.saveType === 1) {
        let termsSend = JSON.parse(JSON.stringify(this.allTerms))
        for (let item of termsSend.termsGroup) {
          for (let one of item.terms) {
            let str = ''
            if (one.selectedOptions[0] === 'event') {
              str = one.selectedOptions[2].split('@')
            } else {
              str = one.selectedOptions[1].split('@')
            }
            let firAttr = one.selectedOptions[0]
            one.attr = firAttr
            one.secAttr = str[0]
            one.option = null
            one.relationOptions = null
          }
        }
        // 防止重复点击
        this.isDisabled = true
        let id = this.$route.query.id
        editGroupManageDetail(termsSend, id).then((res) => {
          if (res.data.code === 0) {
            this.isDisabled = false
            this.searchData = []
            this.load()
            _g.toastMsg('success', '修改群组成功,群组的变更需要一段时间,请稍后刷新')
          } else {
            this.isDisabled = false
            _g.toastMsg('error', res.data.error)
          }
        })
      } else if (this.saveType === 2) {
        let termsSend = JSON.parse(JSON.stringify(this.allTerms))
        for (let item of termsSend.termsGroup) {
          for (let one of item.terms) {
            let str = ''
            if (one.selectedOptions[0] === 'event') {
              str = one.selectedOptions[2].split('@')
            } else {
              str = one.selectedOptions[1].split('@')
            }
            let firAttr = one.selectedOptions[0]
            one.attr = firAttr
            one.secAttr = str[0]
          }
        }
        // 防止重复点击
        this.isDisabled = true
        let id = this.$route.query.id
        addGroupManageDetail(termsSend, id).then((res) => {
          if (res.data.code === 0) {
            this.isDisabled = false
            this.searchData = []
            this.load()
            _g.toastMsg('success', '添加客户成功,群组的变更需要一段时间,请稍后刷新')
          } else {
            this.isDisabled = false
            _g.toastMsg('error', res.data.error)
          }
        })
      }
    },
    // 点击编辑打开高级查询
    edit () {
      this.isHigher = true
      this.saveType = 1
      this.result = []
      this.lastId = 0
    },
    // 静态点击添加客户出现高级查询
    addNewCustomer () {
      const { id: modelId, } = this.$route.params
      const { id, type } = this.$route.query
      router.push({ path: '/home/audiences-group-manage-append/' + modelId + '?type=' + type + '&id=' + id })
    },
    // 获取子组件的查询条件
    getAllTerms (value) {
      this.allTerms = value
    },
    // 计算刷新客户数据（智能数组页面）
    refreshCustomer () {
      _g.toastMsg('success', '正在统计中，请耐心等待')
      this.showNum = 1
      const { id: modelId, } = this.$route.params
      const { type, id } = this.$route.query
      let data = {
        id,
        modelId,
        type,
        name: this.groupName,
        groupId: this.editForm.group_id,
        search: this.downloadQuery
      }
      audEditGroup(data).then((res) => {
        if (res.data.code == 200) {
          this.type = parseInt(type)
          if (this.timeaa === null) {
            this.search.start_time = ''
            this.search.end_time = ''
          } else {
            this.search.start_time = this.timeaa[0]
            this.search.end_time = this.timeaa[1]
          }
          let rowList = []
          // 获取rowList
          getAudListShowSix(modelId).then((audListShowSixRes) => {
            if (audListShowSixRes.data.code == 200) {
              getCusAttrList(modelId).then((resp) => {
                if (resp.data.code == 200) {
                  let data = resp.data.result
                  let normal = []
                  let notNormal = []
                  for (let attr of data) {
                    if (attr.isNormal === 0) {
                      notNormal.push(attr)
                    } else {
                      normal.push(attr)
                    }
                  }
                  // 总的设置列属性
                  let arr = JSON.parse(audListShowSixRes.data.result.fields)
                  for (let a of arr) {
                    for (let item of normal) {
                      if (item.identity === a.identity) {
                        a.name = item.name
                      }
                    }
                  }
                  // 处理发给后台的表头
                  for (let one of arr) {
                    if (one.isChecked === 1) {
                      rowList.push(one)
                    }
                  }
                  let timer = setInterval(() => {
                    getAudGroupDetail(id, this.search.start_time, this.search.end_time, this.page, this.limit, 1, rowList, modelId).then((res) => {
                      if (res.data.code == 200) {
                        console.log(res.data.result , '66666----')
                        const { name, type, number, updateTime, createTime, groupId, audiencesSearchResult } = res.data.result
                        this.groupName = name
                        this.query.type = parseInt(type)
                        this.customerCount = number
                        this.query.update_time = updateTime
                        this.query.create_time = createTime
                        this.editForm.group_id = groupId === 0 ? '' : groupId
                        this.tableData = audiencesSearchResult.list
                        this.headerList = audiencesSearchResult.header
                        this.totalCount = audiencesSearchResult.total
                        console.log(this.editForm, '667788888')
                        if (number > -1) {
                          clearInterval(timer)
                          this.showNum = 0
                        }
                      }
                    })
                  }, 5000)
                }
              })
            }
          })
        } else {
          _g.toastMsg('error', res.data.message)
          this.editDialog = false
        }
      })
    },
    // 获取客户属性
    getCustomerAttributes () {
      getCustomerAttributeList().then((res) => {
        if (res.data.code === 0) {
          this.identities = res.data.data
        }
      })
    },
    downloadFiles () {
      if (this.customerCount === 0) {
        _g.toastMsg('error', '没有数据可导出')
        return
      }
      let search = {
        allRelationship: 'and',
        termsGroup: [
          {
            inOperator: 'and',
            terms: []
          }
        ]
      }
      // 开始传导出的查询参数
      search.termsGroup[0].terms.push({
        attr: 'group',
        endValue: '',
        relationship: '',
        secAttr: 'inGroup',
        startValue: '',
        type: '',
        value: [0, this.$route.query.id]
      })
      if (this.timeaa === null) {
        this.search.start_time = ''
        this.search.end_time = ''
      } else {
        this.search.start_time = this.timeaa[0]
        this.search.end_time = this.timeaa[1]
        this.search.start_time = this.evalTime(this.search.start_time)
        this.search.end_time = this.evalTime(this.search.end_time)
      }
      let modelId = this.$route.params.id
      // 是否全选
      // 属性集合
      // 发送下载参数
      getAudExportList(search, modelId, this.rowLists).then(response => {
        _g.toastMsg('href', '')
        this.exportDialog = false
      }).catch((error) => {
        _g.toastMsg('error', error)
      })
    },
    // 下载文件
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    // 处理分页
    handleSizeChange (val) {
      this.limit = val
      this.load()
    },
    handleCurrentChange (page) {
      this.page = page
      this.load()
    },
    // 加载群组列表
    load () {
      const { type, id } = this.$route.query
      const { id: modelId } = this.$route.params
      let rowList = []
      this.type = +type
      if (this.timeaa === null) {
        this.search.start_time = ''
        this.search.end_time = ''
      } else {
        this.search.start_time = this.timeaa[0]
        this.search.end_time = this.timeaa[1]
        this.search.start_time = this.evalTime(this.search.start_time)
        this.search.end_time = this.evalTime(this.search.end_time)
      }
      // 获取rowList
      getAudListShowSix(modelId).then((audListShowSixRes) => {
        if (audListShowSixRes.data.code == 200) {
          getCusAttrList(modelId).then((resp) => {
            if (resp.data.code == 200) {
              let data = resp.data.result
              let normal = []
              let notNormal = []
              for (let attr of data) {
                if (attr.isNormal === 0) {
                  notNormal.push(attr)
                } else {
                  normal.push(attr)
                }
              }
              // 总的设置列属性
              let arr = JSON.parse(audListShowSixRes.data.result.fields)
              for (let a of arr) {
                for (let item of normal) {
                  if (item.identity === a.identity) {
                    a.name = item.name
                  }
                }
              }
              // 处理发给后台的表头
              for (let one of arr) {
                if (one.isChecked === 1) {
                  rowList.push(one)
                }
              }
              this.rowLists = rowList
              let termsSend = JSON.parse(JSON.stringify(this.allTerms))
              deleteTermsSendKey(termsSend)
              const search = termsSend
              // 获取群组详情
              getAudGroupDetail(id, this.search.start_time, this.search.end_time, this.page, this.limit, 1, rowList, modelId, search, +type).then((res) => {
                if (res.data.code == 200) {
                  console.log(res.data.result, 'res.data.result=====')
                  const { userGroup, list, header, total } = res.data.result
                  const { name, query, createTime, updateTime, number, groupId } = userGroup.group
                  this.groupName = name
                  this.query.type = parseInt(type)
                  this.customerCount = number
                  this.query.update_time = updateTime
                  this.query.create_time = createTime
                  this.downloadQuery = JSON.parse(query)
                  this.editForm.group_id = groupId === 0 ? '' : groupId
                  this.tableData = list
                  this.headerList = header
                  this.totalCount = total
                  console.log(this.editForm, 'total')
                  console.log(total, 'total')
                  this.loadingAll = false
                } else {
                  this.loadingAll = false
                }
              })
            }
          })
        }
      })
    },
    // 收起筛选和展开筛选
    closeAndOpen () {
      if (this.hide === true) {
        this.closeChoose = '展开筛选'
        this.hide = false
      } else {
        this.closeChoose = '收起筛选'
        this.hide = true
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getAudiencesName(to.params.id, to)
      // 通过 `vm` 访问组件实例
      vm.getAudGroupGroupLists(to.params.id)
      vm.load()
    })
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    next()
  },
  beforeRouteUpdate (to, from, next) {
    this.getAudGroupGroupLists(to.params.id)
    this.getAudiencesName(to.params.id, to)
    this.load(to.params.id)
    next()
  },
  async created () {
    let query = JSON.parse(sessionStorage.getItem('groupDetailQuery'))
    if (!query) {
      this.load()
    }
    this.getCustomerAttributes()
    this.isShowHigherSearch = `${this.$route.query.type}` === GROUP_TYPE['static']
    const { id: modelId, } = this.$route.params
    const result = await getAudListShowSix(modelId)
    const allRowList = JSON.parse(result.data.result.fields)
    this.checkedRowList = allRowList.filter(ele => ele.isChecked === 1)
    this.allTerms = INIT_SEARCH
  }
}
</script>

<style scoped>
.mr32 {
  margin-right: 32px;
}
.mr16 {
  margin-right: 16px;
}
.show {
  display: inline-block;
}
.hide {
  display: none;
}
.refresh {
  font-size: 18px;
  color: #39c6cd;
  cursor: pointer;
}
.terms {
  line-height: 20px;
  width: 280px;
  background: #effbfb;
  margin: 10px 10px 0 10px;
  font-size: 14px;
  text-align: left;
}
.group-detail {
  width: 300px;
  background: #fff;
}
.group-detail .title {
  width: 280px;
  height: 60px;
  line-height: 60px;
  color: #333;
  background: #fff;
  border-bottom: 1px solid #e7e7e7;
  text-align: left;
  padding-left: 20px;
}
.group-detail .detail-item {
  width: 280px;
  margin: 0 auto;
  border-bottom: 1px solid #e5e5e5;
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: space-between;
  color: #666;
  font-size: 14px;
}
.detail-item .label {
  width: 100px;
  text-align: right;
}
.detail-item .value {
  width: 170px;
  text-align: left;
  padding-left: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-menu-vertical-demo {
  position: relative;
}
.add-group-btn {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 18px;
  right: 10px;
}
.add-group-btn:hover i {
  color: #1ab394;
}
.add-group-btn i {
  display: block;
  font-size: 20px;
  color: #666;
  cursor: pointer;
}
.text-align-left {
  text-align: left;
}
.text-align-right {
  text-align: right;
}
.table-title {
  text-align: left;
}
.save-btn {
  padding: 0 15px;
  height: 30px;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  float: right;
  color: #fff;
  font-size: 14px;
  background: #1890FF;
  margin-top: 5px;
  cursor: pointer;
}
::-webkit-scrollbar {
  width: 6px; /*滚动条宽度*/
  height: 16px; /*滚动条高度*/
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px; /*滚动条的背景区域的圆角*/
  background-color: #f5f5f5; /*滚动条的背景颜色*/
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px; /*滚动条的圆角*/
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #ccc; /*滚动条的背景颜色*/
}
.left-menu-item {
  min-width: 266px;
  width: 20%;
  padding: 0;
  padding-bottom: 0px;
  background-color: #fff;
  height: auto;
  box-sizing: border-box;
}
.left-menu-item:hover {
  background-color: #fff;
}
</style>
